



import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { DonationDocuments as documents, donorCheckbox } from "./Documents";
import {undertakingDocuments as documents2,undertakingCheckbox} from "./Documents";
import ModalComp from "../../../Components/ModalComp";
import ButtonComp from "../../../Components/ButtonComp/ButtonComp";
import CustomInput from "../../../Components/InputCompo/CustomInput";
import CustomSelection from "../../../Components/SelectionComp/CustomSelection";
import { InputCompo } from "../../../Components/InputCompo/InputCompo";
import { ContributionGet, ContributionRegistration } from "../../../Store/auth/register";
import { useMutation, useQuery } from "@tanstack/react-query";
import { ParagraphComp } from "../../../Components/ParagraphComp/ParagraphComp";
import { enqueueSnackbar } from "notistack";
import { set } from "react-hook-form";
import { DataArraySharp } from "@mui/icons-material";
import AddDonation from "./AddDonation";

const DonationInformation = () => {
  const gsnNoFromStorage = localStorage.getItem("gsn_no");

  const { data: questions, isLoading } = useQuery({
    queryKey: "Contribution",
    queryFn: () => ContributionGet(gsnNoFromStorage ? gsnNoFromStorage : ""),
  });

  
  

  const [initialValues, setInitialValues] = useState({});
  const [initialValues2, setInitialValues2] = useState({});
  const [donorPaymentDetails, setDonorPaymentDetails] = useState([]); // Array to store donor payment details
  const [openPopup, setOpenPopup] = useState({}); // State to control modal visibility and index
  const [selectedRows, setSelectedRows] = useState([]); // Track selected rows
  const [editIndex, setEditIndex] = useState(null); // Track the index of the donor being edited

const handleOpenPopup = (index) => {
  if (index >= 0 && index < donorPaymentDetails.length) {
    // View/Edit mode: Populate initialValues with the selected donor's data
    setInitialValues(donorPaymentDetails[index]);
    setEditIndex(index); // Store the index of the donor being edited
  } else {
    // Add mode: Reset initialValues to default
    const defaultValues = {
      ...documents.reduce((acc, field) => {
        acc[field.question_no] = ""; // Default to empty string
        return acc;
      }, {}),
      ...donorCheckbox.reduce((acc, checkbox) => {
        if (checkbox.isCustomInput) {
          acc[checkbox.name] = ""; // Default to empty string
        } else {
          acc[checkbox.name] = false; // Default to false
        }
        return acc;
      }, {}),
    };
    setInitialValues(defaultValues);
    setEditIndex(null); // Reset edit index for add mode
  }

  // Open the modal
  setOpenPopup({ popup: true, index: index });
};

  // Function to close the modal
  const handleClosePopup = () => {
    setOpenPopup({ popup: false });
    setEditIndex(null);
  };


  const handleDeleteRow = (index) => {
    if (index >= 0 && index < donorPaymentDetails.length) {
      // Delete a single row
      const updatedDonors = donorPaymentDetails.filter((_, i) => i !== index);
      setDonorPaymentDetails(updatedDonors);
      setSelectedRows(selectedRows.filter((i) => i !== index)); // Remove the deleted row from selectedRows
    }
  };
  
  const handleBulkDelete = () => {
    // Delete all selected rows
    const updatedDonors = donorPaymentDetails.filter((_, index) => !selectedRows.includes(index));
    setDonorPaymentDetails(updatedDonors);
    setSelectedRows([]); // Clear selected rows
  };




  useEffect(() => {
    // Check if API response is available
    const apiData = questions?.documents || {};
    const savedData =
      JSON.parse(localStorage.getItem("ContributionData")) || {};

    // Initialize form values with default data if API data is not available
    const formValues = {
      // Reduce over `documents` to populate initial values
      ...documents.reduce((acc, field) => {
        acc[field.question_no] =
          apiData[field.question_no] || ""; // Default to empty string if no data
        return acc;
      }, {}),

      // Reduce over `undertakingCheckbox` to populate initial values
      ...donorCheckbox.reduce((acc, checkbox) => {
        if (checkbox.isCustomInput) {
          // Handle custom input fields for checkboxes
          acc[checkbox.name] =
            apiData[checkbox.name] || savedData[checkbox.name] || "";
        } else {
          // For regular checkboxes, default to `false` if no data is available
          acc[checkbox.name] =
            apiData[checkbox.name] || savedData[checkbox.name] || false;
        }
        return acc;
      }, {}),
    };

    // Set form values (either from API, localStorage, or default)
    setInitialValues(formValues);
  }, [questions]);

  useEffect(() => {
      // Check if API response is available
      const apiData = questions?.documents || {};
  
      // Initialize form values with default data if API data is not available
      const formValues = {
        // Reduce over `documents` to populate initial values
        ...documents2.reduce((acc, field) => {
          acc[field.question_no] =
            apiData[field.question_no] || ""; // Default to empty string if no data
          return acc;
        }, {}),
  
        // Reduce over `undertakingCheckbox` to populate initial values
        ...undertakingCheckbox.reduce((acc, checkbox) => {
          if (checkbox.isCustomInput) {
            // Handle custom input fields for checkboxes
            acc[checkbox.name] =
              apiData[checkbox.name] || "";
          } else {
            // For regular checkboxes, default to `false` if no data is available
            acc[checkbox.name] =
              apiData[checkbox.name] || true;
          }
          return acc;
        }, {}),
      };
  
      // Set form values (either from API, localStorage, or default)
      setInitialValues2(formValues);
    }, [questions]);

    const name_of_organisation = questions?.documents?.name_of_organisation
    const data = questions?.documents
    

    useEffect(() => {
      if(questions?.documents?.donor_payment_details){
        setDonorPaymentDetails(questions?.documents?.donor_payment_details)
      }
    }, [questions])
    
    

  const modelSchema = Yup.object().shape(
        documents.reduce((schema, field) => {
          if (field.mandatory === 1 && field.type.toLowerCase() !== "section") {
            let validator = Yup.string().required(`${field.question} is required`);
    
            if (field.validation) {
              switch (field.validation.toLowerCase()) {
                case "email":
                  validator = Yup.string()
                    .email("Invalid email address")
                    .required(`${field.question} is required`);
                  break;
                case "number":
                  validator = Yup.string()
                    .matches(/^\d{10}$/, "Invalid Number. It should be 10 digits.")
                    .required(`${field.question} is required`);
                  break;
                case "pan":
                  validator = Yup.string()
                    .matches(
                      /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                      "Invalid PAN Number. It should be in the format: ABCDE1234F."
                    )
                    .required(`${field.question} is required`);
                  break;
                case "pincode":
                  validator = Yup.string()
                    .matches(/^\d{4}$|^\d{6}$/, "PIN code must be exactly 6 digits")
                    .required(`${field.question} is required`);
                  break;
                case "areacode":
                  validator = Yup.string()
                    .matches(/^(123|456|789)$/, "Incorrect area code")
                    .required(`${field.question} is required`);
                  break;
                case "website":
                  validator = Yup.string()
                    .url("Please enter a valid URL")
                    .required(`${field.question} is required`);
                  break;
                case "mobile":
                  validator = Yup.string()
                    .matches(/^(?:[0-9]{10}|[0-9]{7})$/, "Invalid contact number")
                    .required(`${field.question} is required`);
                  break;
                case "darpan":
                  validator = Yup.string()
                    .test(
                      "is-valid-darpan",
                      "Darpan Id should be in the format: XX/1234/1234567",
                      (value) =>
                        value?.toUpperCase() === "NA" ||
                        /^([A-Z]{2}\/\d{4}\/\d{7})$/.test(value)
                    )
                    .required(`${field.question} is required`);
                  break;
                case "password":
                  validator = Yup.string()
                    .min(8, "Password must be at least 8 characters long")
                    .required(`${field.question} is required`);
                  break;
                case "multiselect dropdown":
                  validator = Yup.array().required(`${field.question} is required`);
                  break;
                case "attach":
                  validator = Yup.object().required(
                    `${field.question} is required`
                  );
    
                  break;
                case "amount":
                  validator = Yup.string()
                    .matches(
                      /^\d+$/,
                      "Amount of Donation should contain only numerals"
                    )
                    .max(20, "Amount of Donation can be up to 20 digits only")
                    .required(`${field.question} is required`);
                  break;
                default:
                  validator = Yup.string().required(
                    `${field.question} is required`
                  );
    
                  break;
              }
            }
    
            schema[field.question_no] = validator;
          }
    
          return schema;
        }, {})
      );

      const modelSchema2 = Yup.object().shape(
          documents2.reduce((schema, field) => {
            if (field.mandatory === 1 && field.type.toLowerCase() !== "section") {
              let validator = Yup.string().required(`${field.question} is required`);
      
              if (field.validation) {
                switch (field.validation.toLowerCase()) {
                  case "email":
                    validator = Yup.string()
                      .email("Invalid email address")
                      .required(`${field.question} is required`);
                    break;
                  case "number":
                    validator = Yup.string()
                      .matches(/^\d{10}$/, "Invalid Number. It should be 10 digits.")
                      .required(`${field.question} is required`);
                    break;
                  case "pan":
                    validator = Yup.string()
                      .matches(
                        /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                        "Invalid PAN Number. It should be in the format: ABCDE1234F."
                      )
                      .required(`${field.question} is required`);
                    break;
                  case "pincode":
                    validator = Yup.string()
                      .matches(/^\d{4}$|^\d{6}$/, "PIN code must be exactly 6 digits")
                      .required(`${field.question} is required`);
                    break;
                  case "areacode":
                    validator = Yup.string()
                      .matches(/^(123|456|789)$/, "Incorrect area code")
                      .required(`${field.question} is required`);
                    break;
                  case "website":
                    validator = Yup.string()
                      .url("Please enter a valid URL")
                      .required(`${field.question} is required`);
                    break;
                  case "mobile":
                    validator = Yup.string()
                      .matches(/^(?:[0-9]{10}|[0-9]{7})$/, "Invalid contact number")
                      .required(`${field.question} is required`);
                    break;
                  case "darpan":
                    validator = Yup.string()
                      .test(
                        "is-valid-darpan",
                        "Darpan Id should be in the format: XX/1234/1234567",
                        (value) =>
                          value?.toUpperCase() === "NA" ||
                          /^([A-Z]{2}\/\d{4}\/\d{7})$/.test(value)
                      )
                      .required(`${field.question} is required`);
                    break;
                  case "password":
                    validator = Yup.string()
                      .min(8, "Password must be at least 8 characters long")
                      .required(`${field.question} is required`);
                    break;
                  case "multiselect dropdown":
                    validator = Yup.array().required(`${field.question} is required`);
                    break;
                  case "attach":
                    validator = Yup.object().required(
                      `${field.question} is required`
                    );
                    break;
                  default:
                    validator = Yup.string().required(
                      `${field.question} is required`
                    );
                    break;
                }
              }
      
              schema[field.question_no] = validator;
            }
      
            return schema;
          }, {})
        );

  const donorFormik = useFormik({
    initialValues: initialValues,
    validationSchema: modelSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      // Transform checkbox values to 1 or 0
      const transformedValues = {
        ...values,
        ...donorCheckbox.reduce((acc, checkbox) => {
          if (!checkbox.isCustomInput) {
            acc[checkbox.name] = values[checkbox.name] ? 1 : 0;
          }
          return acc;
        }, {}),
      };
  
      if (editIndex !== null) {
        // Editing an existing donor
        const updatedDonors = [...donorPaymentDetails];
        updatedDonors[editIndex] = transformedValues; // Update the existing donor
        setDonorPaymentDetails(updatedDonors);
      } else {
        // Adding a new donor
        setDonorPaymentDetails([...donorPaymentDetails, transformedValues]);
      }
  
      // Close the modal and reset the form
      handleClosePopup();
      donorFormik.resetForm()
    },
  });

  // Formik for the rest of the data (main form)
  const mainFormik = useFormik({
    initialValues: initialValues2,
    validationSchema: modelSchema2,
    enableReinitialize: true,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const transformedValues = {
          guidestar_number: gsnNoFromStorage,
          name_of_organisation:name_of_organisation,
          ...values,
          ...undertakingCheckbox.reduce((acc, checkbox) => {
            if (!checkbox.isCustomInput) {
              acc[checkbox.name] = values[checkbox.name] ? 1 : 0;
            }
            return acc;
          }, {}),
        };
  
        const finalData = {
          args: {
            ...transformedValues,
            donor_payment_details: donorPaymentDetails, // Include donor payment details
          },
        }; 
        // Optionally, navigate to the next page or perform another action
        await submitReg(finalData);
        // console.log(finalData);

        
      } catch (error) {
        console.error(error);
      } finally {
        setSubmitting(false);
      }
    },
  });
  const handleCreateSuccess = () => {
      enqueueSnackbar("success!", { variant: "success" });
      // localStorage.clear('ContributionData')
    };
  
    const handleCreateError = (error) => {
      if (error?.response?.data.status_code >= 500) {
        enqueueSnackbar(error?.response?.data?.status_message, {
          variant: "error",
        });
      } else {
        enqueueSnackbar(error?.response?.data?.message || error?.message, {
          variant: "error",
        });
      }
    };
  
    const createFarmerMutationOptions = {
      onSuccess: handleCreateSuccess,
      onError: handleCreateError,
    };
  
    const {
      mutate: submitReg,
      // data: regFinalData,
      // isPending: mainRegistration
    } = useMutation({
      mutationFn: ContributionRegistration,
      ...createFarmerMutationOptions,
    });

    // console.log(Object.keys(data).length);
    const [showFullModal, setShowFullModal] = useState(false);

  return (
    <>
      <div className="flex justify-end mb-2">
        <ButtonComp
          className="px-[20px] h-[40px] text-white bg-[#004878] rounded-full py-[5px]"
          onClick={() => setShowFullModal(true)}
        >
          Add
        </ButtonComp>
      </div>

      {/* Modal with the whole component inside */}
      <ModalComp
        width="90%"
        modalIsOpen={showFullModal}
        closeModal={() => setShowFullModal(false)}
      >
        <AddDonation/>
      </ModalComp>
      <div className="p-4">
        {/* Table to display donor payment details */}
        <div className="flex flex-col pb-4">
          <div className="flex rounded-tl-[20px] rounded-tr-[20px] border-2 p-[20px] justify-between items-center">
            <h2 className="text-black text-2xl m-0">Donor Payment Details</h2>
            <div>
              {selectedRows.length !== 0 && <ButtonComp
                onClick={handleBulkDelete}
                disabled={selectedRows.length === 0} // Disable if no rows are selected
                className="px-[20px] h-[40px] text-[#004878] border-2 bg-transparent border-[#004878] rounded-full py-[5px] mr-1"
              >
                Delete
              </ButtonComp>}
              <ButtonComp
                onClick={() => handleOpenPopup()}
                className="px-[20px] h-[40px] text-white bg-[#004878] rounded-full py-[5px]"
              >
                Add
              </ButtonComp>
            </div>
            
          </div>
          <table className="border-collapse border-2 w-[100%]">
            <thead className='border-b-2'>
              <tr>
                
                { donorPaymentDetails.length !== 0 && <th className="p-[10px] w-[50px] whitespace-nowrap">
                  <input
                    className="w-[20px] h-[20px]"
                    type="checkbox"
                    checked={selectedRows.length === donorPaymentDetails.length}
                    onChange={(e) => {
                      if (e.target.checked) {
                        // Select all rows
                        setSelectedRows(donorPaymentDetails.map((_, index) => index));
                      } else {
                        // Deselect all rows
                        setSelectedRows([]);
                      }
                    }}
                  />
                </th>}
                <th className="p-[10px] w-[20%]">Mode of Payment</th>
                <th className="p-[10px] w-[20%]">Date of Cheque</th>
                <th className="p-[10px] w-[20%]">Amount</th>
                <th className="p-[10px] w-[20%]">Donor Name</th>
                <th className="p-[10px] w-[20%]">More View</th>
              </tr>
            </thead>
            <tbody>
              {donorPaymentDetails.map((donor, index) => (
                <tr key={index} className="hover:bg-gray-100">
                  <td className="p-[10px] w-[50px] whitespace-nowrap">
                    <input
                      className="w-[20px] h-[20px]"
                      type="checkbox"
                      checked={selectedRows.includes(index)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          // Add the row index to selectedRows
                          setSelectedRows([...selectedRows, index]);
                        } else {
                          // Remove the row index from selectedRows
                          setSelectedRows(selectedRows.filter((i) => i !== index));
                        }
                      }}
                    />
                  </td>
                  <td className="p-[10px] w-[20%]">{donor.mode_payment}</td>
                  <td className="p-[10px] w-[20%]">{donor.date_of_cheque}</td>
                  <td className="p-[10px] w-[20%]">{donor.amount_of_donation}</td>
                  <td className="p-[10px] w-[20%]">{donor.donors_name}</td>
                  {/* <td className="p-[10px] w-[20%]">{donor.name_of_bank}</td> */}
                  <td className="p-[10px] w-[20% - 50px]">
                    <ButtonComp  
                      onClick={() => handleOpenPopup(index)} // Pass the index
                      className="rounded-full text-[white] bg-[#004878] px-[10px] py-[2px]"
                    >
                      View
                    </ButtonComp>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Modal for adding donor payment details */}
        <ModalComp
          width="90%"
          modalIsOpen={openPopup?.popup}
          closeModal={handleClosePopup}
        >
          <form onSubmit={donorFormik.handleSubmit} className="space-y-4">
          <div className="flex flex-col gap-[30px]">
            <div className="flex flex-col gap-[20px]">
              <div className="">
                <ParagraphComp
                  className="text-black text-2xl"
                  text="Donation Details"
                />
              </div>
              <ParagraphComp
                className="text-black text-base leading-8"
                text={`Please fill a separate entry/ record for every donor. All donations should favour "Civil Society Information Services India", the public charitable trust which runs GuideStar India.We accept only contributions from domestic sources of funds. We do not accept cash and donations from foreign sources.`}
              />
              <div className="">
                <ParagraphComp
                  className="text-black text-2xl"
                  text="PLEASE DO NOT DEPOSIT CASH AND DO NOT MAKE DONATIONS FROM FOREIGN SOURCE."
                />
              </div>
            </div>
            <div className="w-[100%] flex-wrap flex gap-[24pt]">
              {documents.slice(0, 7).map((Fields) => (
                <>
                  {Fields.type.toLowerCase() === "text" ||
                  Fields.type.toLowerCase() === "number" ||
                  Fields.type.toLowerCase() === "date" ? (
                    <div className="w-[47%]">
                      <CustomInput
                        required
                        {...donorFormik.getFieldProps(Fields.question_no)}
                        name={Fields.question_no}
                        label={Fields.question}
                        type={Fields.type}
                        onBlur={donorFormik.handleBlur}
                      />
                      <ParagraphComp
                        className="text-[red] text-[10px] px-[8px] mt-1"
                        text={
                          donorFormik.values?.[Fields.question_no] &&
                          donorFormik.errors?.[Fields.question_no]
                        }
                      />
                      <ParagraphComp
                        className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                        text={Fields.description}
                      />
                    </div>
                  ) : Fields.type.toLowerCase() === "dropdown" ? (
                    <div className="w-[47%]">
                      <>
                        <CustomSelection
                          required
                          options={Fields?.options}
                          {...donorFormik?.getFieldProps(Fields?.question_no)}
                          name={Fields.question_no}
                          label={Fields.question}
                        />
                        {/* <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={TempFormik?.values?.[Fields.question_no] && TempFormik?.errors?.[Fields.question_no]} /> */}
                        <ParagraphComp
                          className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                          text={Fields.description}
                        />{" "}
                      </>
                    </div>
                  ) : (
                    ""
                  )}
                </>
              ))}
            </div>
            <div className="">
              <ParagraphComp
                className="text-black text-2xl"
                text="Donor Details"
              />
            </div>
            <div className="w-[100%] flex-wrap flex gap-[24pt]">
              {documents.slice(7, 11).map((Fields) => (
                <>
                  {Fields.type.toLowerCase() === "text" ||
                  Fields.type.toLowerCase() === "number" ||
                  Fields.type.toLowerCase() === "date" ? (
                    <div className="w-[47%]">
                      <CustomInput
                        required
                        {...donorFormik.getFieldProps(Fields.question_no)}
                        name={Fields.question_no}
                        label={Fields.question}
                        type={Fields.type}
                        onBlur={donorFormik.handleBlur}
                      />
                      <ParagraphComp
                        className="text-[red] text-[10px] px-[8px] mt-1"
                        text={
                          donorFormik.values?.[Fields.question_no] &&
                          donorFormik.errors?.[Fields.question_no]
                        }
                      />
                      <ParagraphComp
                        className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                        text={Fields.description}
                      />
                    </div>
                  ) : Fields.type.toLowerCase() === "dropdown" ? (
                    <div className="w-[47%]">
                      <>
                        <CustomSelection
                          required
                          options={Fields?.options}
                          {...donorFormik?.getFieldProps(Fields?.question_no)}
                          name={Fields.question_no}
                          label={Fields.question}
                        />
                        {/* <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={TempFormik?.values?.[Fields.question_no] && TempFormik?.errors?.[Fields.question_no]} /> */}
                        <ParagraphComp
                          className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                          text={Fields.description}
                        />{" "}
                      </>
                    </div>
                  ) : (
                    ""
                  )}
                </>
              ))}
            </div>

            <div className="flex flex-col gap-[20px]">
              <div className="">
                <ParagraphComp
                  className="text-black text-2xl"
                  text="Donor’s Address"
                />
              </div>
              <ParagraphComp
                className="text-black text-base leading-8"
                text={`Please provide full mailing address including PIN Code/ Zip code`}
              />
            </div>
            <div className="w-[100%] flex-wrap flex gap-[24pt]">
              {documents.slice(11, 17).map((Fields) => (
                <>
                  {Fields.type.toLowerCase() === "text" ||
                  Fields.type.toLowerCase() === "number" ||
                  Fields.type.toLowerCase() === "date" ? (
                    <div className="w-[47%]">
                      <CustomInput
                        required
                        {...donorFormik.getFieldProps(Fields.question_no)}
                        name={Fields.question_no}
                        label={Fields.question}
                        type={Fields.type}
                        onBlur={donorFormik.handleBlur}
                      />
                      <ParagraphComp
                        className="text-[red] text-[10px] px-[8px] mt-1"
                        text={
                          donorFormik.values?.[Fields.question_no] &&
                          donorFormik.errors?.[Fields.question_no]
                        }
                      />
                      <ParagraphComp
                        className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                        text={Fields.description}
                      />
                    </div>
                  ) : Fields.type.toLowerCase() === "dropdown" ? (
                    <div className="w-[47%]">
                      <>
                        <CustomSelection
                          required={Fields?.mandatory > 0 ? true : false}
                          options={
                            Fields?.question_no === "district"
                              ? Fields?.options?.filter((ele) =>
                                donorFormik.values?.["state"]?.includes(ele.value)
                                )
                              : Fields?.options
                          }
                          {...donorFormik.getFieldProps(Fields.question_no)}
                          name={Fields.question_no}
                          label={Fields.question}
                          noSort={true}
                        />{" "}
                      </>
                    </div>
                  ) : (
                    ""
                  )}
                </>
              ))}
            </div>

            <div className="">
              <ParagraphComp
                className="text-black text-2xl"
                text="Donation Purpose"
              />
            </div>
            {donorCheckbox?.map((Field) => (
              <>
                <label className="flex items-start space-x-2">
                  <InputCompo
                    className="bg-[#004878] flex-shrink-0 text-white w-[20px] h-[20px]"
                    type="checkbox"
                    name={Field.name}
                    checked={donorFormik.values[Field.name]}
                    onChange={donorFormik.handleChange}
                  />
                  <span className="text-black text-wrap ">{Field.text}</span>
                </label>
              </>
            ))}

            <div className="w-[100%] flex-wrap flex gap-[24pt]">
              {documents.slice(17, 18).map((Fields) => (
                <>
                  {Fields.type.toLowerCase() === "text" ||
                  Fields.type.toLowerCase() === "number" ||
                  Fields.type.toLowerCase() === "date" ? (
                    <div className="w-[100%]">
                      <CustomInput
                        {...donorFormik.getFieldProps(Fields.question_no)}
                        name={Fields.question_no}
                        label={Fields.question}
                        type={Fields.type}
                        onBlur={donorFormik.handleBlur}
                      />
                      <ParagraphComp
                        className="text-[red] text-[10px] px-[8px] mt-1"
                        text={
                          donorFormik.values?.[Fields.question_no] &&
                          donorFormik.errors?.[Fields.question_no]
                        }
                      />
                      <ParagraphComp
                        className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                        text={Fields.description}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </>
              ))}
            </div>
            {/* <div className="w-[100%] flex-wrap flex gap-[24pt]">
              {documents.slice(18, 19).map((Fields) => (
                <>
                  {Fields.type.toLowerCase() === "text" ||
                  Fields.type.toLowerCase() === "number" ||
                  Fields.type.toLowerCase() === "date" ? (
                    <div className="w-[100%]">
                      <CustomInput
                        value={Fields.value}
                        name={Fields.question_no}
                        label={Fields.question}
                        type={Fields.type}
                        onBlur={formik.handleBlur}
                        disabled={Fields.disable}
                      />
                      <ParagraphComp
                        className="text-[red] text-[10px] px-[8px] mt-1"
                        text={
                          formik.values?.[Fields.question_no] &&
                          formik.errors?.[Fields.question_no]
                        }
                      />
                      <ParagraphComp
                        className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                        text={Fields.description}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </>
              ))}
            </div> */}
          </div>
            <div className="flex justify-end mt-[15px]">
              <ButtonComp type="submit" className="w-[150px] rounded-full bg-[#004878] p-[6px] text-white border-none">
                Save
              </ButtonComp>
            </div>
          </form>
        </ModalComp>

        {/* Main form for the rest of the data */}
        <form onSubmit={mainFormik.handleSubmit} className="flex flex-col gap-[30px]" >
        <div className="flex flex-col gap-[20px]">
            <div className="">
              <ParagraphComp
                className="text-black text-2xl"
                text="Undertaking Statements"
              />
            </div>
          </div>

          {undertakingCheckbox?.map((Field) => (
            <>
              <label className="flex items-center space-x-2">
                <InputCompo
                  className="bg-[#004878] flex-shrink-0 text-white w-[20px] h-[20px]"
                  required={true}
                  type="checkbox"
                  name={Field.name}
                  checked={mainFormik.values[Field.name]}
                  onChange={mainFormik.handleChange}
                />
                <span className="text-black text-wrap leading-9">
                  {Field.text}
                </span>
              </label>
            </>
          ))}

          <div className="flex flex-col gap-[20px]">
            <div className="">
              <ParagraphComp
                className="text-black text-2xl"
                text="Contact Information"
              />
            </div>
          </div>

          {documents2?.map((Fields) => (
            <>
              {Fields.type.toLowerCase() === "text" ||
              Fields.type.toLowerCase() === "number" ||
              Fields.type.toLowerCase() === "date" ? (
                <div className="w-[100%]">
                  <CustomInput
                    required
                    {...mainFormik.getFieldProps(Fields.question_no)}
                    name={Fields.question_no}
                    label={Fields.question}
                    onBlur={mainFormik.handleBlur}
                  />
                  <ParagraphComp
                    className="text-[red] text-[10px] px-[8px] mt-1"
                    text={
                      mainFormik.values?.[Fields.question_no] &&
                      mainFormik.errors?.[Fields.question_no]
                    }
                  />
                  <ParagraphComp
                    className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                    text={Fields.description}
                  />
                </div>
              ) : (
                ""
              )}
            </>
          ))}
          {data && typeof data === "object" && Object.keys(data)?.length === 2 && <div className="flex justify-end">
            <div className="flex gap-[20px] mb-20">
              {/* <ButtonComp text={'Save'}  className='px-[20px] rounded-full border-1 border-[#004878] text-[#004878] py-[10px]' /> */}
              <ButtonComp
                text={"submit"}
                type={"submit"}
                className="px-[20px] rounded-full bg-[#004878] text-[white] py-[10px]"
              />
            </div>
          </div>}
        </form>
      </div>
    </>
  );
};

export default DonationInformation;
